const topics = [
  { name: '#顶流恋情', count: '328万讨论', hot: true },
  { name: '#乘风破浪2026', count: '256万讨论', hot: true },
  { name: '#暑期档电影', count: '198万讨论', hot: true },
  { name: '#明星离婚潮', count: '175万讨论', hot: false },
  { name: '#LPL夏季赛', count: '152万讨论', hot: true },
  { name: '#网红翻车', count: '138万讨论', hot: false },
  { name: '#国际时装周', count: '121万讨论', hot: false },
  { name: '#新歌首发', count: '108万讨论', hot: true },
  { name: '#综艺名场面', count: '95万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section
      id="topics"
      className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100"
      style={{ scrollMarginTop: '80px' }}
    >
      <div className="w-full max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            大家都在热议的吃瓜话题
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((item, i) => (
            <div
              key={i}
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border transition-colors duration-200 cursor-pointer ${
                item.hot
                  ? 'border-primary-200 bg-primary-50 hover:bg-primary-100 hover:border-primary-300'
                  : 'border-background-300/60 bg-background-50 hover:bg-background-200 hover:border-background-400'
              }`}
            >
              <span className={`text-sm font-medium whitespace-nowrap ${
                item.hot ? 'text-primary-700' : 'text-foreground-700'
              }`}>
                {item.name}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">
                {item.count}
              </span>
              {item.hot && (
                <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-fire-fill text-accent-500 text-xs"></i>
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}